import { render, staticRenderFns } from "./ProjectUpdateModal.vue?vue&type=template&id=6add983b&scoped=true&"
import script from "./ProjectUpdateModal.vue?vue&type=script&lang=js&"
export * from "./ProjectUpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectUpdateModal.vue?vue&type=style&index=0&id=6add983b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6add983b",
  null
  
)

export default component.exports